import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Dropdown, DropdownButton, FormGroup, FormControl, FormLabel, InputGroup } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { faCopy} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


import OrderScanView from '../order/order-scan-view.js'

class QuoteView extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;

		this.dataobject = null;

		this.quote = null;

		
		let title = '';
		let description = '';
		let amount = 0;
		let currency = {symbol: ''};
		let currencies= [];
		let signingkey = null;
		let currentcard = null;
		
		this.state = {
				title,
				description,
				amount,
				currency,
				currencies,
				signingkey,
				currentcard,
				isOwner: false,
				message_text: 'loading...',
				sharelinkmessage: 'loading...',
				sharelink: 'loading...'
		}
	}


	
	// post render commit phase
	componentDidMount() {
		console.log('QuoteView.componentDidMount called');
		
		let mvcmyquote = this.getMvcMyQuoteObject();

		let registration_text = mvcmyquote.t('This quote has been registered.');

		let message_text = mvcmyquote.t(
			'You can order to the vendor the corresponding good or service based on this quote. \
			If you haven\'t yet provided your private key for the corresponding currency, \
			you will be asked to enter it at the next step so that your order is signed. \
			Your private key will be crypted and stored on your device, it will not leave \
			your device at any time and will not be shared with anyone. \
			Your order will then be registered and be accessible to the vendor clicking on \
			the link that has been generated. \
			Send this link to the vendor to complete your order.');
	
		let sharelinkmessage = mvcmyquote.t('You can share this order with the following link:');
		
		
		this.setState({registration_text, message_text, sharelinkmessage});

		this.checkNavigationState().catch(err => {console.log('error in checkNavigationState: ' + err);});
	}

	async checkNavigationState() {
		let mvcmodule = this.getMvcModuleObject();
		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let app_nav_state = this.app.getNavigationState();
		let app_nav_target = app_nav_state.target;

		if (app_nav_target && (app_nav_target.route == 'quote') && (app_nav_target.reached == false)) {
			var params = app_nav_target.params;
			var dataobj = params.dataobject;

			if (dataobj && (dataobj.type === 'quote') && (dataobj.treated !== true)) {
				this.dataobject = dataobj;

				let quote = dataobj;
				this.quote = dataobj;

				let txhash = params.txhash;
	
				let title = quote.title;
				let description = quote.description;
				let amount = quote.amount;
				let currencyuuid = quote.currencyuuid;

				// time
				let registration_text = mvcmyquote.t('This quote has been registered on');

				registration_text += ' ' + mvcmodule.formatDate(quote.blocktime, 'YYYY-mm-dd HH:MM:SS') + '.';
				
	
				// share link
				let currency = await mvcmyquote.getCurrencyFromUUID(rootsessionuuid, currencyuuid)
				.catch(err => {
					console.log('error in QuoteView.checkNavigationState: ' + err);
				});
	
				var sharelink = await this.app.getShareLink(txhash, currency.uuid);
	

				// look if a wallet is open
				let currentcard = null;
				let isOwner = false;

				let unlocked = await this.app.checkWalletUnlocked()
				.catch(err => {
				});

				if (unlocked) {
					// is it the quote owner
					currentcard = await this.app.openCurrencyCard(currencyuuid)
					.catch(err => {});

					if (currentcard) {
						let decryptcard = await mvcmyquote.getWalletDecryptingCard(rootsessionuuid, walletuuid, quote.owner);

						if (decryptcard) {
							isOwner = true;
						}
					}

				}

				this.setState({title, description, amount, currency, isOwner, registration_text, sharelink});

				dataobj.viewed = true;
			}

			// mark target as reached
			app_nav_target.reached = true;
		}
	}

	
	// user actions
	async onSubmit() {
		console.log('onSubmit pressed!');
		
		if (this.dataobject) {
			let params = {action: 'create', txhash: this.dataobject.txhash, currencyuuid: this.dataobject.currencyuuid, dataobject: this.dataobject};
			this.app.gotoRoute('order', params);
		}
		else
			this.app.alert('Quote parameters not found');

		return true;
	}

	async onShareLinkClick() {
		const {sharelink} = this.state;
		
		// create a textarea on the fly, then remove it to
		// be able to copy to clipboard
		var textArea = document.createElement("textarea");
		textArea.value = sharelink;

		document.body.appendChild(textArea);
		textArea.select();
		document.execCommand("Copy");
		textArea.remove();

		this.app.alert("Share link has been copied to clipboard");
	}

	
	// rendering
	renderQuoteView() {
		let { title, description, amount, currency, registration_text, message_text, sharelinkmessage, sharelink, isOwner } = this.state;
		
		return (
			<div className="Form">
				<FormGroup controlId="title">
				  <FormLabel>Quote Title</FormLabel>
				  <FormControl
					disabled
					autoFocus
					type="text"
					value={title}
					onChange={e => this.setState({title: e.target.value})}
				  />
				</FormGroup>

				<FormGroup controlId="description">
				  <FormLabel>Description</FormLabel>
				  <FormControl 
					disabled
					as="textarea" 
					rows="5" 
					autoFocus
					type="text"
					value={description}
					onChange={e => this.setState({description: e.target.value})}
				  />
				</FormGroup>
				
				<FormGroup className="Proposal" controlId="proposal">
				<span className="ProposalCol">
				<FormLabel>Amount</FormLabel>
				  <FormControl 
					disabled
					autoFocus
					type="text"
					value={amount}
					onChange={e => this.setState({amount: e.target.value})}
				  />
				</span>
				<span className="ProposalCol">
				<FormLabel>Currency</FormLabel>
				<InputGroup>
					<FormControl 
						disabled
						autoFocus
						type="text"
						value={currency.symbol}
						onChange={e => this.onChangeCurrency(e)}
					/>
				</InputGroup>
				 </span>
				</FormGroup>

				<div className="TextBox">
				  {registration_text}
			  	</div>

				<div className="TextBox">
					<div>{sharelinkmessage}</div>
					<div className="ShareBlock">
					<span className="ShareLink" onClick={this.onShareLinkClick.bind(this)}>{sharelink}</span>
					<span className="ShareIcon" onClick={this.onShareLinkClick.bind(this)}><FontAwesomeIcon icon={faCopy} /></span>
					</div>
				</div>

				<Button onClick={this.onSubmit.bind(this)} type="submit">
				  Register an order
				</Button>

				<div className="TextBox">
				  {message_text}
			  	</div>


				{(this.dataobject ?
				<div>
				<hr></hr>
				<div>
					<OrderScanView app={this.app} quote={this.dataobject} />
				</div>
				</div> :
				<></>
				)}
			</div>
		  );
	}

	render() {
		return (
			<div className="Container">
				<div className="Title">Quote View</div>
				{ this.renderQuoteView()}
			</div>
		  );
	}
	
}


// propTypes validation
QuoteView.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
	currentwalletuuid: PropTypes.string,
	iswalletlocked: PropTypes.bool,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
		iswalletlocked: state.wallets.islocked,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {QuoteView};
export default connect(mapStateToProps, mapDispatchToProps)(QuoteView);

